import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["name"]
const _hoisted_2 = ["value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _normalizeProps(_guardReactiveProps({..._ctx.$attrs, ..._ctx.$props})), _createSlots({
    default: _withCtx(() => [
      (!_ctx.readOnly)
        ? (_openBlock(), _createElementBlock("input", _mergeProps({
            key: 0,
            ref: "dateInput",
            class: ['gfu-field__input', { 'gfu-field__input--small': _ctx.small }],
            name: _ctx.name,
            type: "date"
          }, { min: $options.minDate, max: $options.maxDate }, {
            pattern: "\\d{4}-\\d{2}-\\d{2}",
            placeholder: "YYYY-MM-DD",
            onBlur: _cache[0] || (_cache[0] = (...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
            onKeyup: _cache[1] || (_cache[1] = (...args) => ($options.onKeyUp && $options.onKeyUp(...args))),
            onInput: _cache[2] || (_cache[2] = (...args) => ($options.handleDateInputValueChange && $options.handleDateInputValueChange(...args))),
            "data-qa": "date-field"
          }), null, 16 /* FULL_PROPS */, _hoisted_1))
        : (_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "text",
            readonly: "readonly",
            value: $options.readOnlyDateValue,
            name: "model.personalInfo.nationalityLocationID",
            class: "gfu-field__input gfu-field__input--readonly",
            "data-qa": "date-field"
          }, null, 8 /* PROPS */, _hoisted_2))
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$slots.description)
      ? {
          name: "field-description",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "description")
          ]),
          key: "0"
        }
      : undefined
  ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
}